// Function to replace all occurrences of a pattern in a string
export function replaceAll(string, pattern, replacement) {
  if (string === null || string === undefined) return string;
  const str = typeof string === "string" ? string : String(string);
  const regex = new RegExp(pattern, "gi"); // 'g' for global, 'i' for case-insensitive
  return str.replace(regex, replacement);
}

//Winrate Replace
export function replaceWinRateLabel(string, pattern, replacement) {
  if (string === null || string === undefined) return string;
  const str = typeof string === "string" ? string : String(string);
  const regex = new RegExp(pattern, "gi"); // 'g' for global, 'i' for case-insensitive
  return str.replace(regex, replacement);
}
